export const createSyllabus = async ({
    BeURL,
    departmentId,
    courseId,
    title,
    order
}) => {
    try {

        const res = await fetch(`${BeURL}/create-syllabus`, {
            method: "POST",
            credentials :'include',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                departmentId,
                courseId,
                title,
                order
            })
        });

        // IMPORTANT: return response
        return await res.json();

    } catch (err) {

        console.log("Create syllabus error:", err);
        return { success: false, message: "Network error" };
    }
};
